import { axiosSarlaft } from "@/plugins/axios";
import type { GlobalFormData } from "@/schemas/multistep/global-form.schema";
import type { AxiosResponse } from "axios";

export const requestService = {
  save: async (data: GlobalFormData): Promise<any> => {
    try {
      const response: AxiosResponse<any, any> = await axiosSarlaft.post(
        `/solicitudes`,
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  downloadPdf: async (id: string): Promise<any> => {
    try {
      const response: AxiosResponse<any, any> = await axiosSarlaft.get(
        `solicitudes/pdf/${id}`,
        {
          responseType: "blob",
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
};
